import {FastV1SetupWizardStepsLists} from 'contents/SetupWizard/content/SetupWizardContentBusiness';
import {TrayType} from 'constants/dataEnum';
import {CommonSetupWizardBusiness} from 'stores/business/setupWizardBusiness/commonSetupWizardBusiness';

import * as ActionType from '../../constants/actionType';
import {WizardFlag, WizardStatus, DefaultInstrumentV1StepsData} from '../../constants/SetupWizardEnum';

// for debugging setup wizard purposes, insert this into initialState.
export const skipToStep = (step) => ({
  currentWizardView: step,
  stepName: FastV1SetupWizardStepsLists[step],
  processedStep: CommonSetupWizardBusiness.getStepNumberByName(step) - 1,
  wizardViewData: [
    ...new Array(step).fill({}),
    {
      ...DefaultInstrumentV1StepsData[step],
      step,
      currentSubstep: 1,
    },
  ],
  wizardStatus: WizardStatus.ONGOING,
  wizardFlag: WizardFlag.NONE,
});

const initialState = {
  currentWizardView: 0,
  processedStep: 0,
  stepName: '',
  wizardViewData: '',
  wizardStatus: WizardStatus.NOT_STARTED,
  wizardFlag: WizardFlag.NONE,
  isWizardNextAllowed: true,
  initialTrayType: TrayType.NORMAL_CADDY,
  autoA1OffsetCallibrationProgress: 0,
  // ...skipToStep(SetupWizardStep.PLATE_COPY_PROTOCOL),
};

export default function dispenseReportStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.WIZARD_SET_CURRENT_WIZARD_VIEW:
      return {...state, currentWizardView: action.currentWizardView};
    case ActionType.WIZARD_INCREMENT_CURRENT_WIZARD_VIEW:
      return {...state, currentWizardView: state.currentWizardView + 1};
    case ActionType.WIZARD_DECREMENT_CURRENT_WIZARD_VIEW:
      return {...state, currentWizardView: state.currentWizardView - 1};
    case ActionType.SET_PROCESSED_STEP:
      return {...state, processedStep: action.processedStep};
    case ActionType.INCREMENT_PROCESSED_STEP:
      return {...state, processedStep: state.processedStep + 1};
    case ActionType.DECREMENT_PROCESSED_STEP:
      return {...state, processedStep: state.processedStep - 1};
    case ActionType.SET_WIZARD_VIEW_DATA:
      return {...state, wizardViewData: action.wizardViewData};
    case ActionType.SET_WIZARD_STEP_DATA: {
      let wizardViewDataTemp = {...state.wizardViewData};
      if (!wizardViewDataTemp) {
        wizardViewDataTemp = {};
      }

      wizardViewDataTemp[action.stepNumber] = {
        step: action.stepNumber,
        ...wizardViewDataTemp[action.stepNumber],
        ...action.data,
      };

      return {...state, wizardViewData: wizardViewDataTemp};
    }
    case ActionType.SET_WIZARD_STATUS:
      return {...state, wizardStatus: action.wizardStatus};
    case ActionType.SET_WIZARD_FLAG:
      return {...state, wizardFlag: action.wizardFlag};
    case ActionType.SET_WIZARD_STEP_NAME:
      return {...state, stepName: action.stepName};
    case ActionType.SET_IS_WIZARD_ALLOWED_NEXT:
      return {...state, isWizardNextAllowed: action.isWizardNextAllowed};
    case ActionType.SET_WIZARD_INITIAL_TRAY_TYPE:
      return {...state, initialTrayType: action.initialTrayType};
    case ActionType.SET_AUTO_A1_OFFSET_CALLIBRATION_PROGRESS:
      return {...state, autoA1OffsetCallibrationProgress: action.progressPercentage};
    case ActionType.STATE_WIZARD_RESET:
      return initialState;
    case ActionType.RESTORE_WIZARD_STATE:
      return action.state;
    default:
      return state;
  }
}
